import qs from 'query-string';

import { GetTokenResponse, GetTokensRequest } from 'interfaces/ApiType/apiType';

import { api } from './index';

export const searchTokensAPI = async ({
  account,
  search,
  network,
}: GetTokensRequest): Promise<GetTokenResponse> => {
  const url = `/account/${account}/tokens`;
  interface ParamObj {
    search?: string;
    chain?: string;
  }
  let params = <ParamObj>{ chain: 'ethereum' };
  if (search && network) params = { search, chain: network };
  if (!search && network) params = { chain: network };

  if (account) {
    const { data } = await api.get(url, {
      params,
      paramsSerializer: (param) => {
        return qs.stringify(param);
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Authorization:
          typeof window !== 'undefined'
            ? `Bearer ${localStorage.getItem('token')}`
            : '',
      },
    });
    return data.token;
  }
  return null;
};
